
export const SET_TABELAPRECO = 'BACKUP_TABELAPRECO';